import React from 'react';
import { Shop } from '../../interfaces/Shop';
import { CheckmarkIcon } from '@commonsku/styles';

type ShopListProps = {
  shops: Shop[],
  selectedShopId?: string | null,
  onSelectShop: (shop: Shop) => void,
  onConnectShop: () => void,
};

const ShopList = ({ shops=[], selectedShopId, onSelectShop, onConnectShop }: ShopListProps) => {
  return (
    <div className="shop-list">
      <div className="shop-list__shops">
        <div className="shop-list__shops-header">
          <p className="shop-list__shops-header-title">Select a commonsku Shop to connect with</p>
          <div className="shop-list__shops-header-description">
            <span>this is a list of your commonsku shops. Make a new one if you need to.</span>
            <a
              className="shop-list__shops-header-button"
              href="/shops.php?create-shopify-shop=1" target="_blank"
            >Create new</a>
          </div>
        </div>
        <div className="shop-list__shops-container">
          <div className="shop-list__shops-container-shops">
            {shops.map(shop => (
              <div
                key={shop.shop_id}
                data-shop-id={shop.shop_id}
                className={`shop-list__shops-container-shop-item ${shop.shop_id === selectedShopId ? 'shop-list__shops-container-shop-item--selected' : ''}`}
                onClick={() => onSelectShop(shop)}
              >
                <span className="shop-list__shops-container-shop-item-name">{shop.shop_name}</span>
                <span className="shop-list__shops-container-shop-item-selected-icon">
                  {shop.shop_id === selectedShopId ? <CheckmarkIcon color='#000' height={20} width={20} viewBox='0 0 20 20' /> : null}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="shop-list__connect-container">
        <button className="shop-list__connect-button" onClick={() => onConnectShop()}>Connect</button>
      </div>
    </div>
  );
};

export default ShopList;
